import styles from './VideoTitle.module.css';

const VideoTitle = ({ title }: { title: string }) => {
  return <h1 className={styles.title}>{title}</h1>;
};

export default VideoTitle;
